// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__pwjBG","error":"Alert_error__EMWxY","error__red":"Alert_error__red__QZ1O9","ok":"Alert_ok__B6-xK","ok__green":"Alert_ok__green__Xq1Ho"};